import { RootState } from "store/index";
import { Menu } from "client/jspPlatformExperiment";

const editingMenu = (state: RootState): Menu | null => state.menuDetail.menu;

const specialDateInfo = (state: RootState) => state.menuDetail.specialDateInfo;

export default {
  editingMenu,
  specialDateInfo,
};
